/**
 * ActionListBlock — the data contract for prioritized action list components.
 *
 * This is a pure TypeScript file with zero framework imports.
 * Backend tool schemas (Zod) should mirror these types.
 */

export interface ActionItem {
  title: string;
  description?: string;
  priority?: 'high' | 'medium' | 'low';
  icon?: string;
  deep_link?: string;
  deep_link_label?: string;
  entity_type?: string;
  metadata?: Record<string, string>;
}

export interface ActionListBlock {
  title: string;
  actions: ActionItem[];
}

export function isValidActionListBlock(data: unknown): data is ActionListBlock {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  if (typeof d.title !== 'string') return false;
  if (!Array.isArray(d.actions) || d.actions.length === 0) return false;
  return d.actions.every(
    (a: unknown) =>
      a && typeof a === 'object' && typeof (a as Record<string, unknown>).title === 'string'
  );
}
